import React, { useState } from "react";
import { Row, Col, DatePicker, Button } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { CloseCircleFilled } from "@ant-design/icons";
import "./Interview.css";
import TextEditor from "../../components/TextEditor/textEditor";
import { useLocation } from "react-router-dom";
// import { deleteDatabase } from 'workbox-core/_private';
import { createInterview } from "../../redux/actions";

export default function Interview() {

  const [date, setdate] = useState([]);
  const [dateGMT, setdateGMT] = useState([]);
  const [ERROR, setERROR] = useState("");
  const [flag, setflag] = useState(true);
  const [message, setMessage] = useState("");
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.createInterviewReducer.loading);
  const error = useSelector((state) => state.createInterviewReducer.error);
  const location = useLocation();

  const InterviewSubmit = () => {
    dispatch(
      createInterview(
        location.state.SourceId,
        "gigs",
        "Schedule",
        location.state.ClientProfileId,
        "615da1a6530309c6f8a46754",
        location.state.DeclineReasonId,
        location.state.GigId,
        "Proposals",
        "Reason1w",
        "1900-01-01T00:00:00.000Z",
        ["2021-11-17T02:45:00.000+00:00", "2021-11-17T02:45:00.000+00:00"]
      )
    );
  };

  // }
  function onChange(value, dateString) {
    var isAvailable = false;
    var currentDate = new Date();
    var formatedDate = moment(currentDate).format("MM DD, YYYY hh:mm a");

    date.map((item) => {
      if (item === dateString) {
        setERROR("This time already exists please select a different time.");
        isAvailable = true;
      }
    });
    if (isAvailable) {
      return;
    }

    if (formatedDate < dateString) {
      if (date.length < 3) {
        setdate([...date, dateString]);
        setdateGMT([...dateGMT, value._d]);
        setERROR("");
      } else {
        setERROR("Please use only valid times and no more than 3.");
      }
    }
  }

  const deleteDate = (e) => {
    setdate(
      date.filter((item) => {
        return item !== e;
      })
    );
  };
  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={18} lg={14} style={{ margin: "auto" }}>
          <Row>
            <Col span="24" className={"titlecontainer-int"}>
              <p className={"title-int"}>Schedule an interview</p>
            </Col>
          </Row>
          <Row>
            <Col span="24" className={"textcontainer"}>
              <h4 className={"text"}>
                Schedule your interview, add a message for the bidder and submit
                to confirm
              </h4>
            </Col>
          </Row>
          {ERROR ? (
            <div className={"errorContainer"}>
              <strong>Oh snap! </strong>
              <span>{ERROR}</span>
            </div>
          ) : null}

          <Row>
            <Col span="24" style={{ textAlign: "left" }}>
              <h4 className={"textbold"}>
                <strong>Interview time </strong>(Offer the bidder up to three
                dates and times for better success)
              </h4>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div className={"datecontainer"}>
                <Row style={{ width: "100%" }}>
                  <Col xs={19} sm={20} md={21} lg={22}>
                    <DatePicker
                      className={"datepicker"}
                      showTime={{ format: "hh:mm a" }}
                      format="DD-MM-YYYY hh:mm a"
                      onChange={onChange}
                      disabledDate={(current) => {
                        return moment().add(-1, "days") >= current;
                      }}
                    />
                  </Col>
                  <Col xs={5} sm={4} md={3} lg={2}>
                    <Button className={"btndate"}>ADD</Button>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <p className={"proposedText"}>
                <strong>Proposed interview times</strong>
              </p>
            </Col>
          </Row>
          {date.length > 0 ? (
            // <p>hello</p>
            <Row style={{ marginBottom: "15px" }}>
              {date.map((item, index) => {
                return (
                  <Col
                    xs={11}
                    sm={10}
                    md={9}
                    lg={7}
                    xl={5}
                    key={index}
                    style={{ marginLeft: "2%" }}
                  >
                    <Row className={"displayDate"}>
                      <div>{item}</div>
                      <div>
                        <CloseCircleFilled onClick={() => deleteDate(item)} />
                      </div>
                    </Row>
                  </Col>
                );
              })}
            </Row>
          ) : null}
          <Row>
            <Col span={24}>
              <TextEditor
                text={message}
                changeText={(text) => {
                  setMessage(text);
                }}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "4%" }}>
            <Col xs={24} sm={24} md={24} lg={12}>
              <Button className={"buttn cancelbtn"}>CANCEL</Button>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12}>
              <Button
                className={"buttn submitbtn"}
                onClick={() => InterviewSubmit()}
              >
                SUBMIT
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
